import { useState, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { Paper, Typography, InputBase, IconButton } from '@mui/material';
import Grid from '@mui/material/Grid';
import SearchIcon from '@mui/icons-material/Search';
import { HomeContext } from '../utils/contexts/homeContext';

const BookingHeader = (props) => {
    const { handleSearchClick } = props;
    const { homeState } = useContext(HomeContext);

    const [bookingSearchText, SetBookingSearchText] = useState(homeState.bookingSearchText.length > 0 ? homeState.bookingSearchText : '');

    const handleSearchButtonClick = async () => {
        const tempSearchText = bookingSearchText.trim();
        SetBookingSearchText(tempSearchText);
        await handleSearchClick(tempSearchText);
    }

    return (
        <Paper>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="stretch"
            >
                <Grid size={3}>
                    <Typography variant="h5" sx={{ p: 2 }}>
                        Nurse Service Bookings
                    </Typography>
                </Grid>
                <Grid size={8}>
                    <Paper variant="outlined"
                        sx={{ display: 'flex', alignItems: 'center', mt: 1, ml: 2 }}
                    >
                        <InputBase value={bookingSearchText}
                            sx={{ ml: 1, flex: 1 }}
                            placeholder="Search nurse name / duty / patient name / place"
                            onChange={(event) => {
                                SetBookingSearchText((event.target.value ?? '').trim());
                            }}
                        />
                        <IconButton type="button" sx={{ p: '10px' }} aria-label="search nurse" onClick={handleSearchButtonClick}>
                            <SearchIcon />
                        </IconButton>
                    </Paper>
                </Grid>
                <Grid size={1}></Grid>
            </Grid>
        </Paper>

    );
}
export default BookingHeader;